import { colorLabelQueryKeys } from './colorLabelQueryKeys.js';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useWoody } from '../../woody/woody.js';
import { useContextAccessToken } from '../../permission/contexts/AnonShareTokenContext.js';

const useQueryFolderLabels = (folderId) => {
  const { client } = useWoody();
  const accessToken = useContextAccessToken();
  return useQuery({
    queryKey: colorLabelQueryKeys.folder(folderId),
    queryFn: async () => {
      const res = await client.v2({
        endpoint: "/v2/folders/{folderId}/color-labels",
        params: {
          folderId
        }
      }, {
        query: {
          accessToken
        }
      });
      return res.data.labels;
    },
    enabled: !!folderId
  });
};
const useQueryFolderLabelsHelpers = () => {
  const queryClient = useQueryClient();
  const invalidate = (folderId) => {
    queryClient.invalidateQueries({
      queryKey: colorLabelQueryKeys.folder(folderId)
    });
  };
  const updateCachedFolderLabel = (folderId, labelId, name) => {
    queryClient.setQueryData(colorLabelQueryKeys.folder(folderId), (data) => {
      if (!data) {
        return data;
      }
      return data.map((label) => {
        if (label.id === labelId) {
          return {
            ...label,
            name
          };
        }
        return label;
      });
    });
  };
  return {
    invalidate,
    updateCachedFolderLabel
  };
};

export { useQueryFolderLabels, useQueryFolderLabelsHelpers };
//# sourceMappingURL=useQueryFolderLabels.js.map
